import {Component} from 'react';
import './index.less';
import { BrowserRouter as Router, Route, Link} from 'react-router-dom'
import $ from 'jquery';
import { products } from '../../component/products';
import jQuery from 'jquery-easing';
import {withRouter} from 'react-router-dom'
import { hideMask } from '../../component/cart';
import { changeUrl } from '../../common/changeUrl';


const toggleCover = (name) => {
  $(`#${name.short}`).attr('src',name.details[2])
}

const toggleCover2= (name) => {
  $(`#${name.short}`).attr('src',name.specCover)
}

class Collections extends Component {
  
  componentWillMount() {
    jQuery(".slideMask").animate({
      left: '-100vw'
    },1500,"easeInCubic",function(){
      $(".slideMask").css("left","100vw")
    })
    
  }
  
  componentDidMount(){
    if(!$(".collection").hasClass('active')){
      $(".collection").addClass('active')
    }
    $(".exclusive").removeClass('active')
    $(".discover").removeClass('active')
    window.history.scrollRestoration = 'manual'
  }

  componentDidUpdate(prevProps, prevState, snapshot){
    hideMask()
    changeUrl()
  }

  
  
  render () {
    return (
      <div className="container collection">
        <div className='collection-menu'>
          <div className='product-item-wrapper'><div className='all product-item active' style={{"font-size":"22px"}}>SÉLECTION</div></div>
          <div className='product-list'>
            <div className='product-item-wrapper'><Link to={'/' + products.FR.b.url} className="product-item b">{products.FR.b.specName}</Link></div>
            <div className='product-item-wrapper'><Link to={'/' + products.FR.f.url} className="product-item f">{products.FR.f.specName}</Link></div>
            <div className='product-item-wrapper'><Link to={'/' + products.FR.g.url} className="product-item a">{products.FR.g.specName}</Link></div>
            <div className='product-item-wrapper'><Link to={'/' + products.FR.c.url} className="product-item c">{products.FR.c.specName}</Link></div>
            <div className='product-item-wrapper'><Link to={'/' + products.FR.e.url} className="product-item e">{products.FR.e.specName}</Link></div>
            <div className='product-item-wrapper'><Link to={'/' + products.FR.k.url} className="product-item i">{products.FR.k.specName}</Link></div>
            <div className='product-item-wrapper'><Link to={'/' + products.FR.d.url} className="product-item d">{products.FR.d.specName}</Link></div>
            <div className='product-item-wrapper'><Link to={'/' + products.FR.l.url} className="product-item i">{products.FR.l.specName}</Link></div>
            <div className='product-item-wrapper'><Link to={'/' + products.FR.m.url} className="product-item i">{products.FR.m.specName}</Link></div>
            <div className='product-item-wrapper'><Link to={'/' + products.FR.i.url} className="product-item i">{products.FR.i.specName}</Link></div>
          </div>
        </div>
        <div className='collection-item'>
          <div className='section one'>
            <Link to={'/' + products.FR.e.url} className="items">
              <div className='item-cover'>
                <img src={products.FR.e.specCover} alt={products.FR.e.specName} id={products.FR.e.short} onMouseEnter={() => toggleCover(products.FR.e)} onMouseLeave={() => toggleCover2(products.FR.e)}></img>
              </div>
              <div className='item-info'>
                <div className='item-info-name'>{products.FR.e.specName}</div>
                <div className='item-info-spec'> 
                  <div className='item-info-volumn'>{products.FR.e.specIntro}</div>
                  
                  </div>
              </div>
            </Link>
              <Link to={'/' + products.FR.c.url} className="items">
                  <div className='item-cover'>
                    <img src={products.FR.c.specCover} alt={products.FR.c.specName} id={products.FR.c.short} onMouseEnter={() => toggleCover(products.FR.c)} onMouseLeave={() => toggleCover2(products.FR.c)}></img>
                  </div>
                  <div className='item-info'>
                    <div className='item-info-name'>{products.FR.c.specName}</div>
                    <div className='item-info-spec'> 
                      <div className='item-info-volumn'>{products.FR.c.specIntro}</div>
                      
                      </div>
                  </div>
                </Link>
              <Link to={'/' + products.FR.d.url} className="items">
                <div className='item-cover'>
                  <img src={products.FR.d.specCover} alt={products.FR.d.specName} id={products.FR.d.short} onMouseEnter={() => toggleCover(products.FR.d)} onMouseLeave={() => toggleCover2(products.FR.d)}></img>
                </div>
                <div className='item-info'>
                  <div className='item-info-name'>{products.FR.d.specName}</div>
                  <div className='item-info-spec'> 
                    <div className='item-info-volumn'>{products.FR.d.specIntro}</div>
                    
                    </div>
                </div>
              </Link>
          </div>
          <div className='section two'>
            <div className='left'>
            <Link to={'/' + products.FR.g.url} className="items">
              <div className='item-cover'>
                <img src={products.FR.g.specCover} alt={products.FR.g.specName} id={products.FR.g.short} onMouseEnter={() => toggleCover(products.FR.g)} onMouseLeave={() => toggleCover2(products.FR.g)}></img>
              </div>
              <div className='item-info'>
                <div className='item-info-name'>{products.FR.g.specName}</div>
                <div className='item-info-spec'> 
                  <div className='item-info-volumn'>{products.FR.g.specIntro}</div>
                  
                  </div>
              </div>
            </Link>
            <Link to={'/' + products.FR.b.url} className="items">
              <div className='item-cover'>
                <img src={products.FR.b.specCover} alt={products.FR.b.specName} id={products.FR.b.short} onMouseEnter={() => toggleCover(products.FR.b)} onMouseLeave={() => toggleCover2(products.FR.b)} style={{"object-position":"50% 70%","scale":"120%"}}></img>
              </div>
              <div className='item-info'>
                <div className='item-info-name'>{products.FR.b.specName}</div>
                <div className='item-info-spec'> 
                  <div className='item-info-volumn'>{products.FR.b.specIntro}</div>
                  
                  </div>
              </div>
            </Link>
            {/* <Link to={'/' + products.FR.a.url} className="items">
              <div className='item-cover'>
                <img src={products.FR.a.specCover} alt={products.FR.a.specName} id={products.FR.a.short} onMouseEnter={() => toggleCover(products.FR.a)} onMouseLeave={() => toggleCover2(products.FR.a)}></img>
              </div>
              <div className='item-info'>
                <div className='item-info-name'>{products.FR.a.specName}</div>
                <div className='item-info-spec'> 
                  <div className='item-info-volumn'>{products.FR.a.specIntro}</div>
                  
                  </div>
              </div>
            </Link> */}
            </div>
            <div className='right'>
              <Link to={'/' + products.FR.k.url} className="items">
                  <div className='item-cover'>
                    <img src={products.FR.k.specCover} alt={products.FR.k.specName} id={products.FR.k.short} onMouseEnter={() => toggleCover(products.FR.k)} onMouseLeave={() => toggleCover2(products.FR.k)}></img>
                  </div>
                  <div className='item-info'>
                    <div className='item-info-name'>{products.FR.k.specName}</div>
                    <div className='item-info-spec'> 
                      <div className='item-info-volumn'>{products.FR.k.specIntro}</div>
                      
                      </div>
                  </div>
                </Link>
            </div>
          </div>
          <div className='section one last'>
            
            <Link to={'/' + products.FR.f.url} className="items">
                <div className='item-cover'>
                  <img src={products.FR.f.specCover} alt={products.FR.f.specName} id={products.FR.f.short} onMouseEnter={() => toggleCover(products.FR.f)} onMouseLeave={() => toggleCover2(products.FR.f)}></img>
                </div>
                <div className='item-info'>
                  <div className='item-info-name'>{products.FR.f.specName}</div>
                  <div className='item-info-spec'> 
                    <div className='item-info-volumn'>{products.FR.f.specIntro}</div>
                    
                    </div>
                </div>
              </Link>
              
            
            <Link to={'/' + products.FR.l.url} className="items">
                <div className='item-cover'>
                  <img src={products.FR.l.specCover} alt={products.FR.l.specName} id={products.FR.l.short} onMouseEnter={() => toggleCover(products.FR.l)} onMouseLeave={() => toggleCover2(products.FR.l)}></img>
                </div>
                <div className='item-info'>
                  <div className='item-info-name'>{products.FR.l.specName}</div>
                  <div className='item-info-spec'> 
                    <div className='item-info-volumn'>{products.FR.l.specIntro}</div>
                    
                    </div>
                </div>
              </Link>
              
            <Link to={'/' + products.FR.m.url} className="items">
              <div className='item-cover'>
                <img src={products.FR.m.specCover} alt={products.FR.m.specName} id={products.FR.m.short} onMouseEnter={() => toggleCover(products.FR.m)} onMouseLeave={() => toggleCover2(products.FR.m)}></img>
              </div>
              <div className='item-info'>
                <div className='item-info-name'>{products.FR.m.specName}</div>
                <div className='item-info-spec'> 
                  <div className='item-info-volumn'>{products.FR.m.specIntro}</div>
                  
                  </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    )
  }
}
export default withRouter(Collections);
